import React from 'react';
import T from 'prop-types';
import { ThemeProvider } from 'styled-components';

import { Container } from './style';

// NOTE: className is required in order to use `styled()` fn from styled-components
const TierTag = ({ tier, dot, className }) => (
  <ThemeProvider theme={{ type: `tier_${tier}`, dot }}>
    <Container className={className}>{`Tier ${tier}`}</Container>
  </ThemeProvider>
);

TierTag.defaultProps = {
  className: undefined,
  dot: false,
};

TierTag.propTypes = {
  tier: T.number.isRequired,

  className: T.string,
  dot: T.bool,
};

export default TierTag;
